import { render, staticRenderFns } from "./PasswordForgotten.vue?vue&type=template&id=9a174d18&scoped=true&"
import script from "./PasswordForgotten.vue?vue&type=script&lang=js&"
export * from "./PasswordForgotten.vue?vue&type=script&lang=js&"
import style0 from "./PasswordForgotten.vue?vue&type=style&index=0&id=9a174d18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a174d18",
  null
  
)

export default component.exports